import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.7_@babel+core@7.26.10_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["StyledSection","StyledSectionTitle"] */ "/opt/build/repo/src/app/about/styles.ts");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/images/wing.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/svg/aef-lightmode-logo.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/assets/svg/aef-text-lightmode-logo.svg");
;
import(/* webpackMode: "eager", webpackExports: ["StyledContentBlock","StyledContent"] */ "/opt/build/repo/src/components/blocks/ContentBlock/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["QuoteBlockContainer","QuoteText","QuoteAuthor"] */ "/opt/build/repo/src/components/blocks/QuoteBlockComponent/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/MinorButton/MinorButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/Outline/OutlineButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/buttons/SolidButton/SolidButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledBoardCard","StyledMetaContainer","StyledImage","StyledMetaText","StyledBioContainer"] */ "/opt/build/repo/src/components/cards/BoardMemberCard/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/images/DefaultThumbnailImage/DefaultThumbnailImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/images/Gallery/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyledFigure"] */ "/opt/build/repo/src/components/images/ImageContainer/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledLogoLarge","StyledLogoTextOnly","StyledLogoMedium"] */ "/opt/build/repo/src/components/images/Logo/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledHeroHeading","StyledHeroHeadingContentHome","StyledHeroHeadingContent"] */ "/opt/build/repo/src/components/ui/HeroHeading/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["StyledLayoutContainer"] */ "/opt/build/repo/src/components/ui/LayoutContainer/styles.ts");
